export const meta = {
  title: 'Privacy Policy | PhotoCraft ArtCraft AI',
  description:
    'How PhotoCraft ArtCraft AI (photocraftartcraft.com) handles visitor, account and analytics information.',
  updated_at: '2026-10-22',
};

## Who we are

PhotoCraft ArtCraft AI ("we", "us") operates photocraftartcraft.com, an independent guide to PhotoCraft and VectorCraft, the open-source image and vector editors from the ArtCraft project. We aren't affiliated with ArtCraft, Storyteller or Adobe. Contact us at [support@photocraftartcraft.com](mailto:support@photocraftartcraft.com).

## Downloads go to GitHub

We don't host the installers. Every download button links to the official PhotoCraft or VectorCraft releases on GitHub. When you click one, your browser connects directly to GitHub, and [GitHub's privacy statement](https://docs.github.com/en/site-policy/privacy-policies/github-general-privacy-statement) applies to that request. We never see or store the files you download.

## Online editors run in your browser

The PhotoCraft online editor (photocraftartcraft.com/editor) and VectorCraft online (app.photocraftartcraft.com) are the official open-source web builds, served by us through Cloudflare. They run entirely in your browser: images and drawings you open, create or save are never uploaded to us, and saving downloads the file to your own device. Their preferences are kept in your browser's local storage.

## Information we process

- **Basic request data.** Our hosting provider (Cloudflare) processes IP addresses, browser type and the pages you request so it can deliver and protect the site.
- **Analytics.** If enabled, privacy-friendly analytics tell us which pages are visited and how people found us. We use this only to improve the site.
- **Account data.** If you choose to create an account, we store your email address, name and sign-in details. Passwords are stored hashed.
- **Messages.** If you email us or open a support ticket, we keep that conversation so we can reply.

## Cookies

We use essential cookies for language preference, theme and signed-in sessions. Analytics tools may set their own cookies where they're enabled.

## Sharing

We don't sell personal information. We share it only with service providers that run the site (hosting, email delivery, analytics), or when the law requires it.

## Retention and your choices

We keep account data while your account is open and delete it when you ask. You can request access to, correction of or deletion of your information by emailing [support@photocraftartcraft.com](mailto:support@photocraftartcraft.com).

## Changes

We may update this policy. The date at the top shows when it last changed.
